import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../layouts/one-visual";
import styled from 'styled-components';
import { getRequest } from '../../../../api/ApiService';
import Auth from '../../../../routes/Auth';
import { Loader } from 'react-loaders';

import RedArrowIcon from '../../../../containers/assets/red-arrow.png';

const CourseLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const CourseLink = styled.div`
  width: 100%;
  max-width: 600px;
  height: 52px;
  background: #ffffff;
  display: flex;
  border-radius: 8px;
  border: 1px solid #d5d9dd;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);

  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  img {
    width: 24px;
    height: 24px;
    position: relative;
    top: -1px;
  }
`;

class CareerPathwayStep2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      courses: [],
      loaded: false,
    };
  }

  componentDidMount() {
    const courseId = Number(Auth.getCourseId());

    getRequest(`${process.env.REACT_APP_API_URL}courses/`)
      .then(res => {
        let courses = [];
        const course = res.body.find(i => Number(i.id) === courseId);
        if (course && course.subcourses) {
          courses = course.subcourses.filter(i => [
            'product',
            'marketing',
          ].includes(i.category.toLowerCase()));
        }

        this.setState({
          courses,
          loaded: true,
        })
      })
      .catch(err => {});
  }

  render() {
    const { courses, loaded } = this.state;

    return loaded ? (
      <OneVisualLayout
        section="CAREER PATHWAY"
        title="Product &amp; Marketing"
        paragraph1={(
          <Fragment>
            The product management and marketing functions not only drive innovation, but
            also help attract, acquire, and retain customers.<br />
            Here are a few courses within your program that would help prepare you for a
            meaningful, well paid career in product management or marketing.
          </Fragment>
        )}
        paragraph2={(
          <Fragment>
            To learn more about career pathways and opportunities, we highly recommend
            that you reach out to your career center.
          </Fragment>
        )}
        visual={(
          <CourseLinks>
            {courses.map((course, index) => (
              <CourseLink key={index}>
                <div>{course.name}</div>
                <div>
                  {course.code}
                  <a href={course.url} rel="noreferrer" target="_blank">
                    <img src={RedArrowIcon} alt="red arrow icon" />
                  </a>
                </div>
              </CourseLink>
            ))}
          </CourseLinks>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
          autoHeight: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default CareerPathwayStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/career-pathway/step2.js